import { actionCreatorFactory } from 'typescript-fsa'

const actionCreator = actionCreatorFactory('NOTIFICATIONS')

const showNotificationArea = actionCreator('SHOW_NOTIFICATION_AREA')
const hideNotificationArea = actionCreator('HIDE_NOTIFICATION_AREA')
const setNotificationCount = actionCreator<number>('SET_NOTIFICATION_COUNT')

export {
    showNotificationArea,
    hideNotificationArea,
    setNotificationCount,
}
